import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import AdjustIcon from '@mui/icons-material/Adjust';


const stats = [
  // { value: "98%", label: "Client Satisfaction" },
  { value: "25+", label: "AI & CAD Experts" },
  { value: "20+", label: "Projects Delivered" },
  { value: "12+", label: "Years Experience" },
];

const values = [
  {
    icon: (
      // Lightbulb (Innovation)
      <TipsAndUpdatesIcon/>
    ),
    title: "Innovation at Core",
    desc: "We constantly push the boundaries of what's possible with AI and CAD, staying at the forefront of technological advancements to deliver novel solutions.",
  },
  {
    icon: (
      // User group (Collaboration)
      <PeopleAltIcon/>
    ),
    title: "Client-Centric Collaboration",
    desc: "We work in close partnership with our clients, ensuring our solutions are perfectly aligned with their unique business goals and operational needs.",
  },
  {
    icon: (
<WorkspacePremiumIcon/>      // Award/ribbon (Excellence)
    ),
    title: "Commitment to Excellence",
    desc: "We are dedicated to delivering the highest quality solutions that exceed expectations, drive tangible results, and provide lasting value.",
  },
  {
    icon: (
      // Chip (AI)
      <SmartToyIcon/>
    ),
    title: "Deep AI Expertise",
    desc: "Our team comprises leading AI researchers and engineers with profound expertise across multiple domains, ready to tackle complex challenges.",
  },
  {
    icon: (
      // Drafting/Compass (CAD)
      <ArchitectureIcon/>
    ),
    title: "Strong CAD Foundation",
    desc: "Our rich background in CAD Design, Automation, and Customization provides a unique and robust engineering perspective to all our AI solutions.",
  },
  {
    icon: (
      // Target (Mission-driven)
<AdjustIcon/>    ),
    title: "Mission-Driven Approach",
    desc: "Our mission is to empower businesses with tailored AI, combining deep technical knowledge with a practical understanding of industry needs to make advanced AI accessible and impactful.",
  },
];

const AboutSection: React.FC = () => (
    <>
  <div className="about-bg">
    <Container>
      <div className="text-center mb-4">
        <h2 className="about-title">
          About <span className="brand-gradient-text">WoCons</span>
        </h2>
      </div>
      <div className="about-main-desc mb-3 mx-auto">
        Wocons Private Limited (<span className="about-italic">WoCons</span> - short for WorthConsultants) is a Bengaluru-based technology company. 
        With a strong foundation and proven expertise in CAD Design, CAD Automation, and CAD Customization, 
        we are now channeling our engineering prowess into developing cutting-edge custom AI solutions.
      </div>
      <div className="about-secondary-desc mb-4 mx-auto">
        Our journey began with a commitment to precision and innovation in the CAD domain. 
        Today, we leverage that rich experience to build intelligent AI systems that solve complex business challenges and drive transformative growth for our clients.
      </div>
      <Row className="justify-content-center about-stats-row">
        {stats.map((stat, i) => (
          <Col key={stat.label} md="3" xs="6" className="mb-3 d-flex">
            <Card className="about-stat-card flex-fill text-center">
              <CardBody>
                <div className="about-stat-value">{stat.value}</div>
                <div className="about-stat-label">{stat.label}</div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
      <div className="about-divider"></div>
    </Container>
    
  </div>
   <div className="core-values-bg">
    <Container>
      <div className="text-center mb-4">
        <h2 className="core-values-title">Our Core Values & Mission</h2>
        <div className="core-values-subtitle mx-auto">
          These principles guide every project and partnership at <span className="brand-italic">WoCons</span>.
        </div>
      </div>
      <Row className="justify-content-center g-4">
        {values.map((value, idx) => (
          <Col key={idx} md="4" className="mb-4 d-flex">
            <Card className="core-value-card flex-fill text-center">
              <CardBody>
                <div className="core-value-icon mb-2 mx-auto">{value.icon}</div>
                <div className="core-value-title">{value.title}</div>
                <div className="core-value-desc">{value.desc}</div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </div>
  </>
);

export default AboutSection;
